import { Link } from 'react-router-dom'
import { Wordmark } from '@/components/Wordmark'

const columns = [
  {
    heading: 'Firm',
    links: [
      { to: '/about', label: 'About' },
      { to: '/strategy', label: 'Strategy' },
      { to: '/track-record', label: 'Track record' },
      { to: '/contact', label: 'Contact' },
    ],
  },
  {
    heading: 'Investors',
    links: [
      { to: '/invest', label: 'Investing with us' },
      { to: '/for-investors', label: 'Due diligence' },
      { to: '/operator-questions', label: 'Questions to ask an operator' },
      { to: '/fit', label: 'Is this a fit?' },
    ],
  },
  {
    heading: 'Resources',
    links: [
      { to: '/resources', label: 'Guides' },
      { to: '/resources/calculators', label: 'Calculators' },
      { to: '/resources/cleveland-overview', label: 'Cleveland market' },
    ],
  },
]

export function SiteFooter() {
  return (
    <footer className="bg-navy text-[#c5ced8]">
      <div className="mx-auto max-w-7xl px-5 pt-16 pb-10 md:px-8">
        <div className="grid gap-12 md:grid-cols-[1.3fr_repeat(3,1fr)]">
          <div>
            <Link to="/" className="text-[1.5rem] text-white" aria-label="Fairmeadow Capital, home">
              <Wordmark />
            </Link>
            <p className="mt-5 max-w-xs text-sm leading-relaxed">
              Direct real estate ownership, professionally managed.
              <br />
              Cleveland, Ohio.
            </p>
          </div>

          {columns.map((col) => (
            <nav key={col.heading} aria-label={col.heading}>
              <h2 className="mb-4 font-sans text-sm font-semibold tracking-normal text-white">{col.heading}</h2>
              <ul className="space-y-2.5 text-sm">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="transition-colors hover:text-white">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-14 border-t border-white/15 pt-8 text-xs leading-relaxed text-[#9fabb8]">
          <p className="max-w-4xl">
            Nothing on this website is an offer to sell, or a solicitation of an offer to buy, any security. Any
            offering is made only through definitive offering documents, and only to persons eligible to receive them.
            Past performance does not guarantee future results. Real estate investments are illiquid and involve risk,
            including loss of principal.
          </p>
          <div className="mt-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
            <p>&copy; {new Date().getFullYear()} Fairmeadow Capital</p>
            {/* `Link`, not `<a>`: an anchor would full-page-reload the SPA. */}
            <nav className="flex flex-wrap items-center gap-x-6 gap-y-2" aria-label="Legal and social">
              <Link to="/privacy" className="hover:text-white">
                Privacy policy
              </Link>
              <Link to="/accessibility" className="hover:text-white">
                Accessibility
              </Link>
              <a
                href="https://instagram.com/fairmeadow.capital"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white"
              >
                Instagram
              </a>
              <a
                href="https://www.facebook.com/fairmeadowcapitalrealestate"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white"
              >
                Facebook
              </a>
            </nav>
          </div>
        </div>
      </div>
    </footer>
  )
}
